import { CONTACT, ASSETS } from "../data/menu";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F4EFE6] border-t border-[#E6DFD3] py-12 sm:py-16"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 items-start">
          <div className="md:col-span-1 flex items-start gap-3">
            <img
              src={ASSETS.logo}
              alt="Logo Pizzería Estilo Gali"
              className="h-14 w-14 object-contain rounded-full bg-[#F5EBD3] p-1.5 border border-[#E6DFD3]"
            />
            <div>
              <div className="font-serif text-2xl tracking-tight text-[#2B241D] leading-none">
                Estilo<span className="text-[#D96C42]">.</span>Gali
              </div>
              <div className="font-sans text-[10px] uppercase tracking-[0.3em] text-[#5C5146] mt-2">
                Pizzería · Al horno
              </div>
            </div>
          </div>

          <div>
            <div className="font-sans text-xs uppercase tracking-[0.2em] text-[#D96C42] mb-4">
              Horario
            </div>
            <div className="font-serif text-lg text-[#2B241D] leading-relaxed">
              {CONTACT.hours}
            </div>
          </div>

          <div>
            <div className="font-sans text-xs uppercase tracking-[0.2em] text-[#D96C42] mb-4">
              Envíos
            </div>
            <div className="font-serif text-lg text-[#2B241D] leading-relaxed">
              {CONTACT.deliveryZone}
            </div>
          </div>

          <div>
            <div className="font-sans text-xs uppercase tracking-[0.2em] text-[#D96C42] mb-4">
              WhatsApp
            </div>
            <a
              href={CONTACT.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="block font-serif text-lg text-[#2B241D] hover:text-[#D96C42] transition-colors"
            >
              {CONTACT.whatsapp}
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#E6DFD3] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-sans text-xs text-[#5C5146]">
            © {new Date().getFullYear()} Pizzería Estilo Gali. Todos los
            derechos reservados.
          </p>
          <p className="font-sans text-xs text-[#5C5146]">
            Hecho con masa, paciencia y fuego.
          </p>
        </div>

        {/* Créditos de creadores */}
        <div
          data-testid="site-credits"
          className="mt-8 pt-6 border-t border-[#E6DFD3]/60 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 text-center"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/3ftint5r_WhatsApp%20Image%202026-07-13%20at%201.57.11%20AM.jpeg"
            alt="The Web Citizens"
            className="h-8 w-8 sm:h-9 sm:w-9 object-contain rounded-md bg-white p-0.5 border border-[#E6DFD3]"
            data-testid="credits-logo"
          />
          <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-3">
            <span className="font-sans text-[10px] uppercase tracking-[0.25em] text-[#5C5146]">
              Sitio creado por
            </span>
            <span
              className="font-serif text-sm text-[#2B241D]"
              data-testid="credits-name"
            >
              The Web Citizens
            </span>
          </div>
          <div className="flex items-center gap-3 text-[11px]">
            <a
              href="mailto:thewebcitizens@gmail.com"
              data-testid="credits-email"
              className="text-[#5C5146] hover:text-[#D96C42] transition-colors"
            >
              thewebcitizens@gmail.com
            </a>
            <span className="text-[#D5CBB8]">·</span>
            <a
              href="https://instagram.com/thewebcitizens"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="credits-instagram"
              className="text-[#5C5146] hover:text-[#D96C42] transition-colors"
            >
              @thewebcitizens
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
